import { memo } from 'react'
import { Node } from 'reactflow'
import { Label } from "@/shared/components/ui/label"
import { Switch } from "@/shared/components/ui/switch"
import { AlertCircle } from "lucide-react"

interface UserContextSwitchProps {
  selectedNode: Node
  onUpdateNodeData: (field: string, value: unknown) => void
  userContextApiConfigured: boolean
  standalone?: boolean  // 是否独立区块（基础 Agent 用）
}

export const UserContextSwitch = memo(({ 
  selectedNode, 
  onUpdateNodeData, 
  userContextApiConfigured,
  standalone = false 
}: UserContextSwitchProps) => {
  const content = (
    <>
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label className="text-sm">用户上下文</Label>
          <p className="text-xs text-slate-500">
            {userContextApiConfigured 
              ? '从外部 API 获取用户上下文注入 Prompt'
              : '需先在项目设置中配置用户上下文 API'}
          </p>
        </div>
        <Switch
          checked={selectedNode.data.user_context ?? false}
          onCheckedChange={(checked) => onUpdateNodeData('user_context', checked)}
          disabled={!userContextApiConfigured}
        />
      </div>
      {!userContextApiConfigured && (
        <p className="text-xs text-amber-600 mt-2 flex items-center gap-1">
          <AlertCircle className="h-3 w-3" />
          请先在项目设置中配置用户上下文 API
        </p>
      )}
    </>
  )

  // 基础 Agent 需要独立区块
  if (standalone) {
    return (
      <div className="pt-2 border-t mt-4">
        {content}
      </div>
    )
  }

  // Structured/Companion Agent 直接返回内容（在 Prompt 区块内）
  return content
})

UserContextSwitch.displayName = 'UserContextSwitch'